import printJS from 'print-js-updated';
import { error as errorToast } from '@/plugins/toast';

class HttpFile {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }

  link(route, params = {}, options = {}) {
    options = {
      method: 'GET',
      ...options,
    };

    if (!route) {
      return Promise.reject(new Error('Invalid url'));
    }

    return this.httpClient.get('/download-token')
      .then(({ data }) => (
        this.httpClient.getUri({
          url: route,
          params: options.method.toUpperCase() === 'POST' ? data : { ...params, ...data },
        })
      ));
  }

  async download(route, params = {}, options = {}) {
    options = {
      method: 'GET',
      name: null,
      ...options,
    };

    const isPost = options.method.toUpperCase() === 'POST';

    const linkParams = {
      ...(params || {}),
      attachment: options.name || true,
    };

    let data;
    try {
      const url = await this.link(route, linkParams, options);
      ({ data } = isPost
        ? await this.httpClient.post(url, params, { responseType: 'blob' })
        : await this.httpClient.get(url, { responseType: 'blob' }));
    } catch (e) {
      await HttpFile.errorHandler(e);
      return;
    }

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(data);
      return;
    }

    const linkEl = document.createElement('a');
    linkEl.type = 'hidden';
    linkEl.href = URL.createObjectURL(data);

    if (options.name) {
      linkEl.download = options.name;
    }

    // Append a link to the body
    document.body.appendChild(linkEl);

    // this is necessary as linkEl.click() does not work on the latest firefox
    linkEl.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      }),
    );

    setTimeout(() => {
      // For Firefox, it is necessary to delay revoking the ObjectURL
      URL.revokeObjectURL(linkEl.href);
      document.body.removeChild(linkEl);
    }, 100);
  }

  print(route, params = {}, options = {}) {
    options = {
      method: 'GET',
      ...options,
    };

    return this.link(route, params, options)
      .then(url => (
        options.method.toUpperCase() === 'POST'
          ? this.httpClient.post(url, params, { responseType: 'arraybuffer' })
          : this.httpClient.get(url, { responseType: 'arraybuffer' })
      ))
      .then(({ data }) => new Promise((resolve) => {
        printJS({
          printable: Buffer.from(data, 'binary').toString('base64'),
          type: 'pdf',
          onLoadingStart: () => {},
          onLoadingEnd: resolve,
          onError: HttpFile.errorHandler,
          base64: true,
        });
      }))
      .catch(HttpFile.errorHandler);
  }

  static async errorHandler(e) {
    if (typeof e === 'string') {
      const message = e.toUpperCase() === 'FORBIDDEN' ? 'Acesso negado' : e;
      errorToast(message, { timeout: 7000 });
      return;
    }

    errorToast(await HttpFile.decodeError(e), { timeout: 7000 });
  }

  static async decodeError(e) {
    const data = e && e.response && e.response.data;

    if (!data || (!(data instanceof Blob) && !(data instanceof ArrayBuffer))) {
      return e;
    }

    try {
      const text = data instanceof Blob
        ? await data.text()
        : Buffer.from(data).toString('utf-8');
      e.response.data = JSON.parse(text);
    } catch (parseError) {
      // response body isn't JSON, keep the original error as-is
    }

    return e;
  }
}

export default HttpFile;
